// ToastContext.js
import React, { createContext, useContext } from 'react';
import { toast } from 'react-toastify';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const showToast = (type, message, options = {}) => {
    
    const typeStyle = {
        success: { className: 'toast-success ph-toast' },
        error: { className: 'toast-error ph-toast' },
        info: { className: 'toast-info ph-toast' },
        warning: { className: 'toast-warning ph-toast' }
    };
    // return toast[type](message, options);
    
    return toast[type](message, {
        ...options,
        ...typeStyle[type]
      });
  };


  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    console.log('useToast must be used within a ToastProvider');
  }
  return context;
};